import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Buscador de productos diligenciados por nombre y de una empresa en especifico.
 *
 * @param {Object} { commit }
 * @param {Integer} company_id
 * @param {String} product_param
 * @author Fernando Claros
 */
export async function filterProductsFilledInByName({ commit }, { company_id, product_param }) {
    commit('dashboard/load', true, { root: true });

    await $http.get(`products/filter-products-filled-in/by-name?company_id=${company_id}&product_param=${product_param}`)
        .then(({ data: response }) => commit('setFilterProductsFilledAttachment', response.data))
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}